export const CHAT_EXCLUDED_PATHS = Object.freeze([
  "/dashboard",
  "/account-dashboard",
  "/account",
  "/checkout",
  "/cameo",
  "/setup",
  "/pca",
  "/signing-studio",
  "/talent/pending",
  "/pendingdashboard",
  "/admin",
]);

const isAtOrUnder = (path) => (prefix) => {
  const base = prefix.toLowerCase();
  return path === base || path.startsWith(`${base}/`);
};

export const isChatExcludedPath = (excludedPaths) => (pathname) =>
  excludedPaths.some(isAtOrUnder(pathname.toLowerCase()));
